import { Form, Col, Row } from "react-bootstrap";
import { CustomSelect, getNewStudentValues } from "../../../../../../_helpers/Helpers";

export function FamilyMemberForm({
  memberName,
  familyMembers,
  familyMember,
  getFamilyMembers,
  getFamilyMember,
  setStudentValues,
  values
 }) {
  const id = memberName + ".familyMembers";

  return (
    <Form.Group as={Row} controlId={id}>
      <Form.Label column sm={4}>
        Mevcut Aile Bireylerinden Seç
      </Form.Label>
      <Col sm={8}>
        <CustomSelect
          options={familyMembers}
          placeholder="En az 3 karakter giriniz"
          onInputChange={val => { if (val.length === 3) getFamilyMembers(val) }}
          onChange={option => getFamilyMember(option.value).then((member) => {
            const newValues = getNewStudentValues(values, familyMember, member);
            setStudentValues(newValues);
          })}
        />
      </Col>
    </Form.Group>
  );
}